//
// Class
//

export type RuntimeFormatResult =
{
	text: string;
	tooltip: string;
};

export class Runtime
{
	seconds: number;

	constructor(minutes: number, seconds: number)
	{
		this.seconds = (minutes * 60) + seconds;
	}

	add(runtime: Runtime)
	{
		this.seconds += runtime.seconds;
	}

	format()
	{
		let hours = Math.floor(this.seconds / 60 / 60);
		let minutes = Math.floor(this.seconds / 60) % 60;
		let seconds = Math.floor(this.seconds % 60);

		const result: RuntimeFormatResult =
		{
			text: "",
			tooltip: "",
		};

		if(hours > 0)
		{
			result.text += hours.toString() + ":";
			result.tooltip += hours.toString() + " hour";

			if(hours > 1)
			{
				result.tooltip += "s";
			}
		}

		if(minutes > 0)
		{
			if(hours > 0)
			{
				result.tooltip += ", ";
			}

			result.tooltip += minutes.toString() + " minute";

			if(minutes > 1)
			{
				result.tooltip += "s";
			}
		}

		if(hours > 0 || minutes > 0)
		{
			result.tooltip += " and ";
		}

		result.text += minutes.toString().padStart(2, "0") + ":";
		result.text += seconds.toString().padStart(2, "0");

		result.tooltip += seconds.toString() + " second";

		if(seconds != 1)
		{
			result.tooltip += "s";
		}

		return result;
	}
}